import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import clsx from 'clsx';
import { getScrollBehavior } from 'core/utils/motion';
import { guidLibGenerator } from 'core/utils/utils';
import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { withTranslation } from 'react-i18next';

const AccordionList2 = ({ arrowView, tabs, onGetLessonItemMessages, onChangeOpenedTabs, shouldScrollIntoViewOnExpand, style }) => {
  const instanceId = useRef(guidLibGenerator()).current;
  const accordionRefs = useRef([]);

  async function onChangeAccordion(e, expanded, item) {
    if (onGetLessonItemMessages && expanded && item?.assignment?.guid) {
      await onGetLessonItemMessages(item.assignment);
    }

    onChangeOpenedTabs(item.id, expanded);
  }

  // Once the expand transition finishes the layout has its final height, so the submodules
  // hidden below the fold are scrolled into view. Fires only on expand (onEntered), never on
  // collapse, and not for defaultExpanded panels on mount (MUI skips the transition there).
  function onAccordionEntered(index) {
    accordionRefs.current[index]?.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
  }

  return (
    <div className={clsx('accordion-list2', `accordion-list2--arrow-${arrowView}`, { 'accordion-list2--simple': style === 'simple' })}>
      {tabs.map((item, i) => {
        const headerId = `${instanceId}-panel-${i}-header`;
        const contentId = `${instanceId}-panel-${i}-content`;

        return (
          <Accordion
            onClick={item.onClick ? item.onClick : undefined}
            key={i}
            ref={(el) => {
              accordionRefs.current[i] = el;
            }}
            className={item.className}
            defaultExpanded={item.defaultExpanded}
            disabled={item.disabled}
            expanded={item.expanded !== undefined ? item.expanded : undefined}
            id={item.id}
            onChange={(e, expanded) => {
              onChangeAccordion(e, expanded, item);
            }}
            TransitionProps={shouldScrollIntoViewOnExpand ? { onEntered: () => onAccordionEntered(i) } : undefined}
          >
            <AccordionSummary expandIcon={<Icon name="chevron-down" size="xl" />} aria-controls={contentId} id={headerId}>
              {item.title}
            </AccordionSummary>
            <AccordionDetails>{item.children}</AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

AccordionList2.propTypes = {
  arrowView: PropTypes.string,
  onChangeOpenedTabs: PropTypes.func,
  onGetLessonItemMessages: PropTypes.func,
  shouldScrollIntoViewOnExpand: PropTypes.bool,
  style: PropTypes.string, //'default' | 'simple'
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      assignment: PropTypes.shape({ guid: PropTypes.string }),
      children: PropTypes.node,
      className: PropTypes.string,
      defaultExpanded: PropTypes.bool,
      disabled: PropTypes.bool,
      expanded: PropTypes.bool,
      id: PropTypes.string,
      title: PropTypes.node,
    })
  ).isRequired,
};

AccordionList2.defaultProps = {
  arrowView: 'right',
  shouldScrollIntoViewOnExpand: false,
  tabs: [],
  onChangeOpenedTabs: () => null,
};

export default withTranslation('course')(AccordionList2);
